<template>
  <section class="pdp-bottom">
    <section id="pdp-story" class="pdp-story">
      <header
        class="bg-cover"
        :class="{
          'no-headline': !product.story_headline,
        }"
      >
        <h2>
          {{ product.story_headline }}
        </h2>
      </header>
      <div class="copy" v-html="product.story"></div>
    </section>
  </section>
</template>

<script>
export default {
  name: 'ProductStory',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.bg-cover {
  background-size: cover !important;
}
</style>
